import React, { Fragment, useEffect, useState } from "react";
import { toastr } from "react-redux-toastr";
import api from "../../../../api";
import "../../../../styles/grid.scss";
import { ContainerLoader } from "../../../../components/loader";
import {
  Customer,
  getInvalidCustomerFieldsEnquiry,
  IActivityListingDetails,
  ILeadActivity,
  ILeadEvent,
  IUpdateEventModel,
} from "../../../../core";
import { useLeadActivities } from "../../../../core/hooks/useLeadActivities";
import { ActivityItemBuilder } from "./activity-item-builder";
import { ActivityModel } from "./add-activity";
import { EditEventPopup } from "./edit-event-popup";
import CustomerEdit from "../../../customer/components/customer-stage-edit/CustomerEdit";
import { useMasterData } from "../../../../core/hooks/useMasterData";
import { useAppSettings } from "../../../../core/hooks/useAppSettings";

interface IPlannedActivityProps {
  activityDetails?: IActivityListingDetails;
  leadId?: string;
  customer?: Customer;
  onUpdateCustomer?: (id: string) => void;
  onReload?: () => void;
}

export const PlannedActivities: React.FunctionComponent<IPlannedActivityProps> = (
  props
) => {
  const masterData = useMasterData(api.settings);
  const appSettings = useAppSettings(api.settings);
  const activities = props.activityDetails?.data ?? [];
  const {
    leadState,
    updateActivity,
    getEventDetails,
    createEventUpdateFormData,
    activityMarkAsDone,
  } = useLeadActivities(api.lead);
  const [currentActivity, setCurrentActivity] = useState<ActivityModel>();
  const [isEditing, setIsEditing] = useState(false);

  const [customerModal, setCustomerModal] = React.useState<{
    isOpen?: boolean;
    id?: string;
  }>({});

  useEffect(() => {
    if (!isEditing) {
      setCurrentActivity(undefined);
    }
  }, [isEditing]);
  const onPressEdit = async (activity: ILeadActivity) => {
    if (activity.event != null) {
      getEventDetails(activity?.event?._id, (eventDetails: ILeadEvent) => {
        const activityModel: ActivityModel = createEventUpdateFormData(
          eventDetails
        );
        setCurrentActivity(activityModel);
        setIsEditing(true);
      });
    } else {
      toastr.error("Error", "Event is null");
    }
  };

  const onSubmitActivity = (apiModel: IUpdateEventModel) => {
    updateActivity(currentActivity?.eventId!, apiModel, () => {
      setIsEditing(false);
    });
  };
  if (activities.length === 0 && !(props.activityDetails?.isLoading ?? false)) {
    return (
      <li className="text-center mb-4 pb-2 position-relative ">
        <span className="bg-gray-300 rounded-pill px-2 font-xxs text-uppercase">
          No Planned activities!
        </span>
      </li>
    );
  }

  return (
    <Fragment>
      <li className="text-center mb-4 pb-2 position-relative ">
        <span className="bg-gray-300 rounded-pill px-2 font-xxs text-uppercase">
          Planned
        </span>
      </li>
      <div className="mb-3">
        {props.activityDetails?.isLoading && (
          <ContainerLoader></ContainerLoader>
        )}
        {activities.map((p, index) => {
          return (
            <div key={"planned-activities-" + index}>
              {ActivityItemBuilder.builder[p.type] != null &&
                ActivityItemBuilder.builder[p.type](
                  p,
                  props.leadId,
                  () => {
                    onPressEdit(p);
                  },
                  props.customer,
                  (id: string) => {
                    setCustomerModal({ isOpen: true, id });
                  },
                  () => {
                    props.onReload?.();
                  }
                )}
            </div>
          );
        })}
      </div>
      {isEditing && currentActivity !== undefined && (
        <EditEventPopup
          isEdit={true}
          currentActivity={currentActivity}
          onClose={() => {
            setIsEditing(false);
          }}
          onSubmit={(updatedEvent) => {
            onSubmitActivity(updatedEvent);
          }}
          leadId={leadState?.leadDetails?._id!}
        ></EditEventPopup>
      )}
      {customerModal?.isOpen && (
        <>
          <CustomerEdit
            onClose={() => setCustomerModal({})}
            id={props?.customer?._id || ""}
            onReload={async () => {
              const customerData = await api.customer.getDetails(
                props?.customer?._id!
              );

              const invalidCustomerFieldsForEnquiry = customerData
                ? getInvalidCustomerFieldsEnquiry(
                    customerData,
                    masterData?.data?.leadStages
                      ?.find((x) => x.code === "enquiry")
                      ?.entity?.find((c) => c.key === "Customer")!
                  )
                : [];

              if (!invalidCustomerFieldsForEnquiry?.length) {
                activityMarkAsDone(
                  leadState?.leadDetails?._id ?? "",
                  customerModal?.id ?? "",
                  () => {
                    props.onReload?.();
                    setCustomerModal({});
                  }
                );
              } else {
                props.onReload?.();
                setCustomerModal({});
              }
            }}
            entity={
              masterData?.data?.leadStages?.find((x) => x.code === "enquiry")
                ?.entity!
            }
            leadDetails={leadState.leadDetails}
          />
        </>
      )}
    </Fragment>
  );
};
